module.exports = __webpack_public_path__ + "static/media/1011637.693850d9.png";